import { render, staticRenderFns } from "./facility-list.vue?vue&type=template&id=63e4cf01&scoped=true"
import script from "./facility-list.vue?vue&type=script&lang=js"
export * from "./facility-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e4cf01",
  null
  
)

export default component.exports